import { useRef, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { BOOKING_URL } from '../constants';
import { gsap, ScrollTrigger, useMotion } from '../lib/motion';

const navLinks = [
  { label: "Estilos", href: "#servicos" },
  { label: "Trabalhos", href: "#portfolio" },
  { label: "Avaliações", href: "#avaliacoes" },
  { label: "Contato", href: "#contato" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuOpenRef = useRef(false);
  menuOpenRef.current = menuOpen;

  // Menu sai do caminho ao descer a página e volta assim que a pessoa sobe.
  const scope = useMotion((header) => {
    const slide = (yPercent) => gsap.to(header, { yPercent, duration: 0.45, ease: 'power3.out', overwrite: 'auto' });
    ScrollTrigger.create({
      start: 120,
      end: 'max',
      onUpdate: (self) => {
        if (menuOpenRef.current) return;
        slide(self.direction === 1 ? -100 : 0);
      },
      onLeaveBack: () => slide(0),
    });
    return () => gsap.set(header, { clearProps: 'transform' });
  });

  return (
    <header
      ref={scope}
      data-testid="navbar"
      className="sticky top-0 z-40 bg-paper/90 backdrop-blur-md border-b border-rule"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="#inicio"
          className="text-xl font-extrabold tracking-tight text-ink"
          data-testid="navbar-logo"
        >
          nyjuliabraids
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-soft hover:text-ink transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-ink text-paper px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-tan transition-colors"
            data-magnetic
            data-testid="nav-booking-btn"
          >
            Agendar horário
          </a>
        </nav>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-ink p-2 -mr-2"
          data-testid="mobile-menu-toggle"
          aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <X size={24} strokeWidth={1.75} /> : <Menu size={24} strokeWidth={1.75} />}
        </button>
      </div>

      {menuOpen && (
        <nav className="md:hidden border-t border-rule px-4 py-2" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="block py-3 text-lg font-semibold text-ink"
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
